 

// Ligero y predecible:
// - info/warn/error: siempre visibles
// - debug/log: silenciados en producción
const isProd: boolean =
  typeof import.meta !== 'undefined' && !!import.meta.env && !!import.meta.env.PROD;

// Reporter opcional (ej. Sentry) para enviar errores
type Reporter = (e: unknown) => void;
let errorReporter: Reporter | null = null;

export function setErrorReporter(r: Reporter) {
  errorReporter = r;
}

export function info(...args: unknown[]): void {
  console.info('[VERAIS]', ...args);
}

export function warn(...args: unknown[]): void {
  console.warn('[VERAIS]', ...args);
}

export function error(...args: unknown[]): void {
  console.error('[VERAIS]', ...args);
  if (errorReporter) {
    const first = args[0];
    const err = first instanceof Error ? first : new Error(String(first));
    try {
      errorReporter(err);
    } catch {
      /* no-op */
    }
  }
}

export function debug(...args: unknown[]): void {
  if (isProd) return;
  console.debug('[VERAIS]', ...args);
}

export function log(...args: unknown[]): void {
  if (isProd) return;
  console.log('[VERAIS]', ...args);
}

export const logger = { info, warn, error, debug, log } as const;
export type Logger = typeof logger;

export default logger;
